import { render } from "./AmbulanceStatus.vue?vue&type=template&id=5cd278fa&scoped=true"
import script from "./AmbulanceStatus.vue?vue&type=script&lang=js"
export * from "./AmbulanceStatus.vue?vue&type=script&lang=js"

import "./AmbulanceStatus.vue?vue&type=style&index=0&id=5cd278fa&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd278fa"]])

export default __exports__